import GenericModel from './generic-model';
import { Role } from './role';
import Employee from './product/employee';
import Asset from './asset';

export class User extends GenericModel {
  firstName?: string;
  lastName?: string;
  username?: string;
  email?: string;
  password?: string;
  phone?: string;
  mobilePhoneNumber?: string;
  roles?: Role[];
  employee?: Employee;
  profilePicture?: Asset;
  companies?: string[];
  party?: string;
  hasNewPortalAccess?: boolean;

  constructor() {
    super();
    this.roles = [];
  }
}

export enum ExternalParty {
  ERA,
}
